import { Tooltip } from "primereact/tooltip";

import styles from "./outlook-card.module.scss";
import type { OutlookCardProps, OutlookKpiDados } from "./types-outlook-card";

function Kpi({ kpi, className }: { kpi: OutlookKpiDados; className?: string }) {
  return (
    <div className={className ? `${styles.kpi} ${className}` : styles.kpi} data-testid={kpi.testId}>
      <span className={styles.kpiRotulo}>{kpi.rotulo}</span>
      <div className={styles.kpiLinha}>
        <span
          className={kpi.excedido ? styles.excedido : styles.kpiValor}
          data-pr-tooltip={kpi.orientacao ?? undefined}
          data-pr-position="top"
          data-testid={kpi.valorTestId}
        >
          {kpi.valor}
        </span>
        {kpi.complemento ? <span className={styles.kpiComplemento}>{kpi.complemento}</span> : null}
      </div>
    </div>
  );
}

/** Card do Controle do Outlook (Figma `plan-controle/kpi`): Total e os indicadores NC e CP; NC negativo mostra "Excedido" em vermelho com a orientação em tooltip. */
export function OutlookCardView({ card }: OutlookCardProps) {
  return (
    <section className={styles.card} aria-label={card.titulo} data-testid={card.testId}>
      <h3 className={styles.titulo}>{card.titulo}</h3>
      <div className={styles.kpis}>
        <Kpi kpi={card.total} className={styles.kpiTotal} />
        <Kpi kpi={card.nc} />
        <Kpi kpi={card.cp} />
      </div>
      {card.nc.excedido ? <Tooltip target={`[data-testid="${card.nc.valorTestId}"]`} /> : null}
    </section>
  );
}
